import { render } from "./PlusButton.vue?vue&type=template&id=85bb50ba&scoped=true"
const script = {}

import "./PlusButton.vue?vue&type=style&index=0&id=85bb50ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bb50ba"]])

export default __exports__